import React from 'react'
import {change as changeFieldValue, Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Select from 'react-select';
import UsuarioEmpresaAgencia from './UsuarioEmpresaAgencia';
import cadastrarUsuariosEmpresaAgencia from '../../../actions/usuario-empresa-agencia/cadastrarUsuariosEmpresaAgencia';
import buscarUsuariosEmpresaAgencia from '../../../actions/usuario-empresa-agencia/buscarUsuariosEmpresaAgencia';
import {showSuccessMsg} from '../../../util/messagesUtil';

export const CabecalhoTabela = () => (
  <div id="header-tabela" className="lista-table">
    <div className="row cabecalho-desktop">
      <div className="col-lg-9 col-xl-9">Agência</div>
      <div className="col-lg-3 col-xl-3">Ações</div>
    </div>
  </div>
);


export class ModalRelacionarAgenciaUsuario extends React.Component {
  constructor (props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.state = {
      agenciaSelecionada: null
    };

  }

  submit () {
    this.props.cadastrarUsuariosEmpresaAgencia(this.props.empresaSelecionada.id, this.props.usuarioSelecionado.usuarioEmpresaId, this.state.agenciaSelecionada.value)
      .then(() => {
          showSuccessMsg('Agência vinculada com sucesso');
          this.props.buscarUsuario()
          this.props.buscarUsuariosEmpresaAgencia(this.props.empresaSelecionada.id, this.props.usuarioSelecionado.usuarioEmpresaId)
          this.limpar();
      })
  }

  exibirComboAgencias (event) {
    let idsAgenciasUsuario = [];
    if(this.props.usuariosEmpresaAgencia && this.props.usuariosEmpresaAgencia.length){
      idsAgenciasUsuario = this.props.usuariosEmpresaAgencia.map(uea => uea.agenciaId);
    }

    return (
      <div>
        <Select
          {...event.input}
          noOptionsMessage={() => ('Nenhuma opção encontrada')}
          placeholder='Selecione uma agência...'
          options={this.props.agencias.filter(agencia => !idsAgenciasUsuario.includes(agencia.id)).map(elemento => (
            {
              label: elemento.nomeComNumero,
              value: elemento.id
            }))}
          onChange={value => this.setState({agenciaSelecionada: value})}
          value={this.state.agenciaSelecionada}
        />
      </div>
    )
  }

  exibirAgenciasUsuario () {
    if (!this.props.usuariosEmpresaAgencia || !this.props.usuariosEmpresaAgencia.length) {
      return <div className='col-12'>
        <div className="mt-2 alert alert-warning text-center" role="alert">
          Não existem agências cadastradas para o usuário.
        </div>
      </div>
    }
    return <React.Fragment>
      <CabecalhoTabela/>
      <div className="lista-table">
        {this.props.usuariosEmpresaAgencia
          .map((usuarioEmpresaAgencia, index) => <UsuarioEmpresaAgencia
            key={index}
            usuarioEmpresaAgencia={usuarioEmpresaAgencia}
            buscarUsuario={this.props.buscarUsuario}
            indice={index}/>)}
      </div>
    </React.Fragment>
  }


  limpar () {
    this.setState({ agenciaSelecionada: null })
  }

  render () {
    const {
      handleSubmit, submitting
    } = this.props;
    return (
      <div className="modal fade show" id='modalRelacionarAgenciaUsuario' role='dialog'
           aria-labelledby='modalRelacionarAgenciaUsuario' aria-hidden='true' data-backdrop='static'>
        <div className={'modal-dialog modal-dialog-centered modal-lg'}>
          <div className="modal-content">
            <div className="modal-header">
              <h5>Relacionar Agência</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                      onClick={() => this.limpar()}>
                <i className="material-icons">
                  &#xe5cd;
                </i>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit(this.submit)}>
                <div className='col-10 col-sm-10 col-md-8'>
                  <label>Agência</label>
                  <Field name='rota' component={this.exibirComboAgencias.bind(this)}/>
                </div>
                <div className='col-10 col-sm-10 col-md-8 '>
                  <button id="btn-salvar"
                          type="submit" disabled={submitting || !this.state.agenciaSelecionada}
                          className="btn btn-laranja mt-2">Incluir
                  </button>
                </div>

              </form>
              {this.exibirAgenciasUsuario()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export function mapStateToProps (state) {
  return {
    empresaSelecionada: state.empresaSelecionada,
    usuarioSelecionado: state.usuarioSelecionado,
    agencias: state.agencias.agencias,
    usuariosEmpresaAgencia: state.usuariosEmpresaAgencia
  }
}


export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    changeFieldValue,
    cadastrarUsuariosEmpresaAgencia,
    buscarUsuariosEmpresaAgencia,
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'formRelacionarAgenciaUsuario'
})(ModalRelacionarAgenciaUsuario));
